import { useTranslation } from "react-i18next";
import { ScrollReveal } from "@/components/ScrollReveal";
import { useScrollLinked } from "@/hooks/useScrollLinked";

/**
 * Proof section. Deliberately contains NO customer quotes: we only show claims
 * we can substantiate (delivered systems, measured throughput, licence model).
 * Quotes may only return here with a real, named, approved reference.
 */
const TestimonialsSection = () => {
  const { t } = useTranslation();
  const { ref: titleRef, progress } = useScrollLinked(0.9, 0.5);

  return (
    <section className="section-y-wide bg-background overflow-hidden">
      <div className="container">
        <div
          ref={titleRef}
          className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-end lg:gap-16"
        >
          <ScrollReveal>
            <h2 className="max-w-[26ch] text-[1.55rem] sm:text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
              {t("testimonials.heading")}
            </h2>
            <div className="mt-6 h-[3px] w-24 bg-border rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-primary to-accent rounded-full"
                style={{ width: `${progress * 100}%` }}
              />
            </div>
          </ScrollReveal>

          {/* Hard numbers — evidence, not decoration */}
          <ScrollReveal delay={120}>
            <dl className="grid grid-cols-3 gap-6 border-t border-border pt-6 lg:gap-10 lg:border-t-0 lg:border-l lg:pt-0 lg:pl-10">
              {(t("testimonials.kpis", { returnObjects: true }) as { value: string; label: string }[]).map((kpi) => (
                <div key={kpi.label}>
                  <dt className="sr-only">{kpi.label}</dt>
                  <dd>
                    <span className="block font-mono text-2xl md:text-3xl font-semibold tabular-nums text-foreground">
                      {kpi.value}
                    </span>
                    <span className="mt-1.5 block text-[11px] md:text-xs leading-snug text-muted-foreground">
                      {kpi.label}
                    </span>
                  </dd>
                </div>
              ))}
            </dl>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
